import { IconProps } from "./Icon.model";

export function Route01({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 3.33333C9.5 1.95262 10.6193 0.833328 12 0.833328C13.3807 0.833328 14.5 1.95262 14.5 3.33333C14.5 4.71404 13.3807 5.83333 12 5.83333C10.6193 5.83333 9.5 4.71404 9.5 3.33333Z"
        fill={fillColor}
      />
      <path
        d="M1.5 12.6667C1.5 11.286 2.61929 10.1667 4 10.1667C5.38071 10.1667 6.5 11.286 6.5 12.6667C6.5 14.0474 5.38071 15.1667 4 15.1667C2.61929 15.1667 1.5 14.0474 1.5 12.6667Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66667 5.66667C2.66667 4.00982 4.00981 2.66667 5.66667 2.66667H8C8.36819 2.66667 8.66667 2.96515 8.66667 3.33334C8.66667 3.70153 8.36819 4.00001 8 4.00001H5.66667C4.74619 4.00001 4 4.7462 4 5.66667C4 6.58715 4.74619 7.33334 5.66667 7.33334H10.3333C11.9902 7.33334 13.3333 8.67648 13.3333 10.3333C13.3333 11.9902 11.9902 13.3333 10.3333 13.3333H8C7.63181 13.3333 7.33333 13.0349 7.33333 12.6667C7.33333 12.2985 7.63181 12 8 12H10.3333C11.2538 12 12 11.2538 12 10.3333C12 9.41286 11.2538 8.66667 10.3333 8.66667H5.66667C4.00981 8.66667 2.66667 7.32353 2.66667 5.66667Z"
        fill={fillColor}
      />
    </svg>
  );
}

